__webpack_require__.p = "/korean-vocab-app/";